const Debug = require('./debug');

const internals = { pending: new WeakMap() };

module.exports = { scheduleBackgroundStartup, measureStartupTask };

async function measureStartupTask(source, stage, task) {

    const startedAt = Date.now();
    let status = 'complete';

    try {
        return await task();
    }
    catch (error) {
        status = 'failed';
        throw error;
    }
    finally {
        try {
            Debug.recordFlow('startup_task', {
                source, stage, status, durationMs: Math.max(0, Date.now() - startedAt)
            });
        }
        catch (error) {
            // Diagnostic storage must never change startup behavior.
        }
    }
}

function scheduleBackgroundStartup({ context, isCurrent, source }) {

    clearTimeout(internals.pending.get(context));

    const timer = setTimeout(() => {

        internals.pending.delete(context);

        if (!isCurrent()) {
            return;
        }

        const tasks = [
            ['chat', () => context.handlers.communication.startGlobalListening()],
            ['announcements', () => context.redux.hooks.dispatch(
                context.actions.dataFetching.fetchAnnouncementConversations()
            )]
        ];

        tasks.forEach(([stage, task]) => {

            if (!isCurrent()) {
                return;
            }

            measureStartupTask(source, stage, task).catch(() => {

                // Optional services must not replace an already usable home page.
                Debug.recordFlow('startup_background_unavailable', { source, stage });
            });
        });
    }, 0);

    internals.pending.set(context, timer);
}
